import React from 'react';
import { Formik, useFormikContext } from 'formik';
import { ConnectedFocusError } from 'focus-formik-error';
/**
 * A wrapper component that imbues <Formik> with additional capabilities, i.e. listening
 * to when a validation error has been triggered. Shares the same props as <Formik>.
 */
export default function FormikWrapper(_ref) {
  let {
    onValidationError,
    isAutoFocusDisabled,
    children,
    ...props
  } = _ref;
  const renderChildren = formikProps => {
    if (typeof children === 'function') {
      // children is a function that returns a ReactNode
      return children(formikProps);
    }
    if ( /*#__PURE__*/React.isValidElement(children) || typeof children === 'string' || typeof children === 'number' || Array.isArray(children)) {
      // children is a ReactNode
      return children;
    }
    console.error('Invalid children type.');
    return null;
  };
  return /*#__PURE__*/React.createElement(Formik, props, formikProps => /*#__PURE__*/React.createElement(React.Fragment, null, onValidationError && /*#__PURE__*/React.createElement(ValidationErrorObserver, {
    callback: onValidationError
  }), !isAutoFocusDisabled &&
  /*#__PURE__*/
  // @ts-expect-error
  React.createElement(ConnectedFocusError, null), renderChildren(formikProps)));
}
function ValidationErrorObserver(_ref2) {
  let {
    callback
  } = _ref2;
  const formikProps = useFormikContext();
  React.useEffect(() => {
    if (formikProps.submitCount > 0 && !formikProps.isSubmitting && !formikProps.isValid) {
      callback(formikProps.errors);
      formikProps.setSubmitting(false);
    }
  }, [formikProps.submitCount, formikProps.isSubmitting]);
  return null;
}